<template>
    <ul class="base-tabs">
        <li
            class="base-tabs__item"
            :class="{ active: tab.type == activeType }"
            v-for="(tab, index) in tabsList"
            :key="index"
            @click="handleTab(tab.type, tab)"
        >
            <svg-icon v-if="tab.newStatus === 1" icon-class="new" class-name="icon-new"></svg-icon>
            {{ tab.title }}
        </li>
    </ul>
</template>

<script>
export default {
    name: 'BaseTabs',
    props: {
        tabsList: {
            type: Array,
            default: () => []
        },
        activeType: {
            type: [Number, String, null],
            default: 0
        },
        tabKey: {
            type: String,
            required: false
        }
    },
    methods: {
        handleTab(type, tab) {
            this.$emit('handleTab', type, tab, this.tabKey);
        }
    },
};
</script>

<style lang="scss" scoped>
.base-tabs {
    display: flex;
    // margin-bottom: 10px;
    min-height: 28px;
    flex-wrap: wrap;

    &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 28px;
        padding: 0 12px;
        border-radius: 4px;
        @include font(rgba(113, 119, 152, 1), 16px, 400);
        cursor: pointer;
        white-space: nowrap;
        margin-bottom: 10px;
        position: relative;
        .icon-new {
            position: absolute;
            width: 22px;
            height: 12px;
            top:-12px;
            right: -12px;
        }

        &:not(:first-child) {
            margin-left: 18px;
        }

        &:hover {
            @include font(rgba(47, 84, 235, 1), 16px, 400);
        }

        &.active {
            background-color: rgba(47, 84, 235, 1);
            color: #fff;

            &:hover {
                color: #fff;
            }
        }
    }
}

// 小屏
@include mq($small) {
    .base-tabs {
        min-height: 21px;

        &__item {
            height: 21px;
            padding: 0 9px;
            border-radius: 10px;
            @include font(rgba(113, 119, 152, 1), 14px, 400);
            cursor: pointer;

            &:not(:first-child) {
                margin-left: 14px;
            }

            &:hover {
                @include font(rgba(47, 84, 235, 1), 14px, 400);
            }
        }
    }
}
</style>
